import React, { Component } from 'react';
import { Route, withRouter, Switch } from 'react-router';
import '../../scripts/facebook.sdk';
import TagManager from 'react-gtm-module'

import NotFound404 from "../../../SHARED/components/notfound/notfound.component";
import Header from "../../../FO/components/header/header.component";
import Footer from "../../../FO/components/footer/footer.component";
import Register from "../register/register.component";
import Login from "../login/login.component";
import Home from "../../../FO/components/home/home.component";
import Movies from "../../../FO/components/movies/movies.component";
import RecentMovies from "../../../FO/components/recentmovies/recentmovies.component";
// import BoxOffice from "../../../FO/components/boxoffice/boxoffice.component";
import MovieTheaters from "../../../FO/components/movietheaters/movietheaters.component";
import Schedule from "../../../FO/components/schedule/schedule.component";
import SoonInCinema from "../../../FO/components/soonincinema/soonincinema.component";
import AllNews from "../../../FO/components/news/allnews.component";
import { matchPath } from 'react-router';
// import EditorialNews from "../../../FO/components/news/editorialnews.component";
// import ChronicsNews from "../../../FO/components/news/chronicsnews.component";
// import PortretNews from "../../../FO/components/news/portretnews.component";
// import FestivalNews from "../../../FO/components/news/festivalnews.component";*/
import GeneralNews from "../../../FO/components/news/generalnews.component";
import SearchResults from "../../../SHARED/components/searchresults/searchresults.component";
import TagsSearchResults from "../../../SHARED/components/tagssearchresults/tagssearchresults.component";
import Serials from "../../../FO/components/serials/serials.component";
import NewsDetails from "../../../FO/components/newsdetails/newsdetails.component";
import Profile from "../../../FO/components/profile/profile.component";
import MovieDetails from "../../../FO/components/moviedetails/moviedetails.component";
import SerialDetails from "../../../FO/components/serialdetails/serialdetails.component";
import FestivalDetails from "../../../FO/components/festivaldetails/festivaldetails.component";
import EditProfile from "../../../FO/components/editprofile/editprofile.component";
import Festivals from "../../../FO/components/festivals/festivals.component";
import ForgotPassword from '../../../SHARED/components/forgotpassword/forgotpassword.component';
import EventDetails from '../../../FO/components/eventdetails/eventdetails.component';
import HallDetailsMobile from '../../../SHARED/components/halldetailsmobile/halldetailsmobile.component';
import Tickets from '../../../FO/components/tickets/tickets.component';
import ThankYou from '../../../FO/components/thankyou/thankyou.component';
import Terms from '../../../FO/components/terms/terms.component';
import Confidentiality from '../../../FO/components/confidentiality/confidentiality.component';
import AboutProject from '../../../FO/components/aboutproject/aboutproject.component';
import Contact from '../../../FO/components/contact/contact.component';
import "../../../FO/resources/js/styles";

import {
    LOGIN_ROUTE,
    REGISTER_ROUTE,
    ROOT_ROUTE,
    ROOT_ROUTE_INDEX,
    SERIALS_ROUTE,
    ALL_MOVIES_ROUTE,
    // BOXOFFICE_ROUTE,
    MOVIE_THEATERS_ROUTE,
    RECENT_MOVIES_ROUTE,
    SOON_IN_CINEMA_ROUTE,
    GENERAL_NEWS_ROUTE,
/*    ALL_NEWS_ROUTE,
    EDITORIAL_NEWS_ROUTE,
    CHRONICS_NEWS_ROUTE,
    PORTRET_NEWS_ROUTE,
    FESTIVAL_NEWS_ROUTE,*/
    SEARCH_RESULTS,
    NEWS_DETAILS_ROUTE,
    PROFILE_ROUTE,
    SCHEDULE_ROUTE,
    SCHEDULE_ROUTE_WITHOUT_PARAMS,
    MOVIE_DETAILS,
    SERIAL_DETAILS,
    FESTIVAL_DETAILS,
    EDIT_PROFILE_ROUTE,
    FESTIVAL_PAGE_ROUTE,
    FORGOT_PASSWORD,
    EVENT_DETAILS,
    NOT_FOUND_ROUTE,
    SEARCH_BY_TAG,
    HALL_ROUTE_FOR_MOBILE,
    TIKETS_ROUTE,
    THANK_YOU_PAGE,
    TERMS_ROUTE,
    CONFIDENTIALITY_ROUTE,
    ABOUT_PROJECT,
    CONTACT_ROUTE,
    ALL_NEWS_ROUTE
} from "../../config/routes";

import connect from "react-redux/es/connect/connect";
import { requestLoginGuest } from '../../actions/user.actions';
import { closeDropDownOnSchedulePageRequest } from '../../actions/general.actions';
import { storeSelectedCinemaLocation } from '../../actions/filters.actions';

const tagManagerArgs = {
    gtmId: 'GTM-MZZDHBZ'
};

TagManager.initialize(tagManagerArgs);

class Router extends Component {

    componentWillMount() {
        if (window.localStorage.getItem("access_token") == null) {
            this.props.requestLoginGuest();
        }
        if (localStorage.getItem("cinema_location")){
            this.props.storeSelectedCinemaLocation(localStorage.getItem("cinema_location"));
        } else {
            this.props.storeSelectedCinemaLocation('Bucuresti');
        }
    }

    getFooterRule() {
        /*if (this.props.location.pathname !== '/') {
            return <Footer />
        }*/
        return <Footer />
    }

    closeDropDownOnSchedulePage() {
        if (this.props.history.location.pathname.search('program') > -1) {
            this.props.closeDropDownOnSchedulePageRequest();
        }
    }

    checkIfHallConfigurationPage = () => {
        const urlString = this.props.location.pathname;
        const keyWord = 'configuratie-sala';
        return urlString.includes(keyWord);
    };

    showGeneralError() {
        let markup = [];
        if( typeof(this.props.general_error) !== "object" ) {
            markup.push(<div key={1} className="general-error-holder">{ this.props.general_error }</div>)
        }
        return markup;
    }

    getAdBackground() {
        const isRouteActive = !!matchPath(
            this.props.location.pathname,
            NEWS_DETAILS_ROUTE
        );
        const locationPathname = this.props.history.location.pathname;
        // if ((locationPathname === ALL_NEWS_ROUTE) || (locationPathname === '/stiri/star-wars') || (isRouteActive && this.props.news_details.article_category === "Star Wars")){
        //     return 'content star-wars-background';
        // } else {
        //     return 'content';
        // }
        return 'content';
    }

    render() {
        const reload = () => window.location.reload();
        return (
            <div className="front" onClick={this.closeDropDownOnSchedulePage.bind(this)}>
                { this.showGeneralError() }
                {
                    !this.checkIfHallConfigurationPage() ? <Header /> : ''
                }

                <div className={this.getAdBackground()}>
                    <Switch>
                        {/* Front Office routes */}
                        {/*<Route path="/" exact component={Homepage} />*/}

                        <Route path="/ads.ext" onEnter={reload} />

                        <Route path={ROOT_ROUTE} exact component={Home} />

                        <Route path={ROOT_ROUTE_INDEX} exact component={Home} />

                        <Route path={LOGIN_ROUTE} exact component={Login} />

                        <Route path={REGISTER_ROUTE} exact component={Register} />

                        <Route path={ALL_MOVIES_ROUTE} exact component={Movies} />

                        <Route path={RECENT_MOVIES_ROUTE} exact component={RecentMovies} />

                        <Route path={SOON_IN_CINEMA_ROUTE} exact component={SoonInCinema} />

                        {/* <Route path={BOXOFFICE_ROUTE} exact component={BoxOffice} /> */}

                        {this.props.cinemaLocations.length && <Route path={MOVIE_THEATERS_ROUTE} render={(props) => <MovieTheaters cinemaLocations={this.props.cinemaLocations} {...props}/>} />}

                        <Route path={SCHEDULE_ROUTE} exact component={Schedule} />

                        <Route path={SCHEDULE_ROUTE_WITHOUT_PARAMS} exact component={Schedule} />

                        <Route path={NEWS_DETAILS_ROUTE} exact component={NewsDetails} />

                        <Route path={ALL_NEWS_ROUTE} exact component={AllNews} />

                        <Route path={GENERAL_NEWS_ROUTE} exact component={GeneralNews} />

                        {/* <Route path={EDITORIAL_NEWS_ROUTE} exact component={EditorialNews} />

                        <Route path={CHRONICS_NEWS_ROUTE} exact component={ChronicsNews} />

                        <Route path={PORTRET_NEWS_ROUTE} exact component={PortretNews} />

                        <Route path={FESTIVAL_NEWS_ROUTE} exact component={FestivalNews} />*/}

                        <Route path={SEARCH_RESULTS} component={SearchResults} />

                        <Route path={SEARCH_BY_TAG} exact component={TagsSearchResults} />

                        <Route path={SERIALS_ROUTE} exact component={Serials} />

                        <Route path={PROFILE_ROUTE} exact component={Profile} />

                        <Route path={EDIT_PROFILE_ROUTE} exact component={EditProfile} />

                        <Route path={MOVIE_DETAILS} exact component={MovieDetails} />

                        <Route path={SERIAL_DETAILS} exact component={SerialDetails} />

                        <Route path={FESTIVAL_DETAILS} exact component={FestivalDetails} />

                        <Route path={FESTIVAL_PAGE_ROUTE} exact component={Festivals} />

                        <Route path={FORGOT_PASSWORD} exact component={ForgotPassword} />

                        <Route path={EVENT_DETAILS} exact component={EventDetails} />

                        <Route path={HALL_ROUTE_FOR_MOBILE} exact component={HallDetailsMobile} />

                        <Route path={TIKETS_ROUTE} exact component={Tickets} />
                        
                        <Route path={THANK_YOU_PAGE} exact component={ThankYou} />
                        
                        <Route path={TERMS_ROUTE} exact component={Terms} />

                        <Route path={CONFIDENTIALITY_ROUTE} exact component={Confidentiality} />

                        <Route path={CONTACT_ROUTE} exact component={Contact} />

                        <Route path={ABOUT_PROJECT} exact component={AboutProject} /> 

                        {/* 404 - Not Found */}
                        <Route path={NOT_FOUND_ROUTE} component={NotFound404} />
                    </Switch>
                </div>
                {
                    !this.checkIfHallConfigurationPage() ? this.getFooterRule() : ''
                }

            </div>
        );
    }
}

const mapStateToProps = state => ({
    cinemaLocations: state.filters.cinemaLocations,
    access_token: state.user.access_token,
    showDropDown: state.errors.showDropDown,
    general_error: state.errors,
    news_details: state.news.newsDetails
});
export default withRouter(connect(mapStateToProps, { requestLoginGuest, closeDropDownOnSchedulePageRequest, storeSelectedCinemaLocation })(Router));



// WEBPACK FOOTER //
// ./src/SHARED/components/router/router.component.js